import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';
import { fomateDate } from '../../utils/fomateDate';
import { deletecustomerThunk } from '../../redux/customer/customerSlice';
import { deletevendorThunk, setvendorEdit } from '../../redux/vendor/vendorSlice';

// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '6px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const InactiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ffc9c9',
  color: '#d9534f',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#d4edda',
  color: '#28a745',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Reject = styled(Chip)(({ theme }) => ({
  background: 'transparent',
  color: '#E95555',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Approve = styled(Chip)(({ theme }) => ({
  backgroundColor: '#2DA85E',
  color: '#fff',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Pending = styled(Chip)(({ theme }) => ({
  backgroundColor: '#F29339',
  color: '#fff',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));


const AllVendor = ({ vendors, page, setPage, start, end, totalItems, itemsPerPage, selectedTab, handleOpenMenu }) => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null)



  const deleteVendor = (password) => {
    dispatch(deletevendorThunk({ id: selectedId, password }))
    setIsModalOpen(false);

  }


  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };

  const handleEditClick = (subcategory) => {
    dispatch(setvendorEdit(subcategory));
    navigate(`/users/editVendor/${subcategory?._id}`)
  };




  return (
    <>

      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>

              <HeaderCell>
                Vendors
                <IconButton onClick={(e) => handleOpenMenu('fullName')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ paddingLeft: '10px' }}>
                Phone number
              </HeaderCell>

              <HeaderCell sx={{ paddingLeft: '10px' }}>
                Email
              </HeaderCell>

              {selectedTab === 0 ?
                <HeaderCell sx={{ paddingLeft: '10px' }}>
                  Admin manager
                </HeaderCell>
                : null}
              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('activeStatus')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Register date
                <IconButton onClick={(e) => handleOpenMenu('createdAt')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {vendors.map((row) => (
              <TableRow key={row._id}>


                <TableCells sx={{
                  width: '20%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      {
                        row?.profileImg ? <img src={row?.profileImg} style={{ width: 44, height: 44, borderRadius: 2 }} /> : <img src="/assets/profile.png" />
                      }
                    </div>
                    <div style={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>

                      <strong style={{ color: '#1D1F2C' }}>{row?.companyName}</strong>
                      <p style={{ fontSize: 12 }}>{row?.fullName}</p>
                    </div>
                  </div>
                </TableCells>

                <ProductText sx={{ width: '13%', color: "#667085", }}>
                  {row?.phone}
                </ProductText>

                <ProductText sx={{ width: '12%', color: "#667085", }}>
                  <div style={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row?.email}
                  </div>
                </ProductText>
                {selectedTab === 0 ?
                  <ProductText sx={{ width: '12%', color: "#667085", }}>
                    {row?.admin?.name || '-'}
                  </ProductText>
                  : null}
                {selectedTab === 0 ?
                  <TableCells sx={{ width: '11%' }}>
                    {row?.activeStatus === "ACTIVE" ? (
                      <ActiveChip label="Active" size="small" />
                    ) :
                      <InactiveChip label="Inactive" size="small" />
                    }
                  </TableCells>
                  : selectedTab === 1 ?
                    <TableCells sx={{ width: '13%', }}>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <Reject label="Reject" size="small" />
                        <Pending label="Pending" size="small" />
                      </div>
                    </TableCells>
                    :
                    <TableCells sx={{ width: '13%', }}>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <Reject label="Reject" size="small" />
                        {/* <Pending label="Pending" size="small" /> */}
                      </div>
                    </TableCells>
                }


                <TableCells sx={{ width: '14%', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)}
                </TableCells>

                <Operations sx={{ width: '11%', }}
                  TableCells={TableCells}
                  viewClick={() => navigate(`/users/vendorDetails/${row?._id}`)}
                  editClick={() => handleEditClick(row)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                  selectedTab={selectedTab}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'Vendor'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteVendor}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default AllVendor;
